import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const RecenterMapIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={className}
        data-testid={testId}
        fill='none'
        height='24'
        viewBox='0 0 17 17'
        width='24'
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M15.2512 0.0857281C15.5417 -0.0664842 15.8981 -0.0124413 16.1301 0.219517C16.3618 0.451401 16.4158 0.806991 16.2638 1.09745L8.48553 15.9471C8.32534 16.2528 7.97695 16.4094 7.64178 16.3269C7.30689 16.2444 7.07163 15.9443 7.07147 15.5994V9.27811H0.750176C0.404984 9.27811 0.104135 9.04202 0.0216605 8.70682C-0.0606065 8.37174 0.0968511 8.02416 0.40252 7.86405L15.2512 0.0857281ZM3.79705 7.77811H7.82147C8.23558 7.77823 8.57147 8.11397 8.57147 8.52811V12.5486L13.8205 2.52713L3.79705 7.77811Z'
            fill='currentColor'
        />
    </svg>
);

export default RecenterMapIcon;
